/**
 * store shipment infomation
 */
import Vue from "vue";

const GeneralItemKey = {
  CARGO_TYPE: "cargoType",
  OTODOKE_KBN: "otodokeKbn",
  SERVICE_KBN: "serviceKbn",
  COOL_OFFER_KBN: "coolOfferKbn",
  PAYMENT_DIV: "paymentDiv",
  PAID_FREE_KBN: "paidFreeKbn",
  COOL_KBN: "coolKbn",
  CURRENCY_CD: "currencyCd",
  SHIPMENT_TERM: "shipmentTerm",
  WEIGHT_UNID_CD: "weightUnidCd",
  LENGTH_UNID_CD: "lengthUnidCd",
  WEIGHT_LIMIT: "weightLimit",
  SIZE_LIMIT: "sizeLimit",
  INVOICE_BY_DOCUMENT: "invoiceByDocument",
  INVOICE_BY_NON_DOCUMENT: "invoiceByNonDocument",
  VAT_REGISTER_DIV: "vatRegisterDiv",
  VAT_REGISTER_DIV_NOTICE: "vatRegisterDivNotice",
  VAT_REGISTER_DIV_HINT: "vatRegisterDivHint"
};

const shipment = {
  // 法人ID
  // 担当店コード
  // 基本情報
  basicInfo: {
    // 出荷指示番号 (shipmentNo)
    shipmentNo: null,
    // サービス種類 (serviceDiv)
    serviceDiv: null,
    // サービス種類ラベル (serviceDivLabel)
    serviceDivLabel: null,
    // 荷主管理番号 (referenceNo)
    referenceNo: null,
    // 出荷予定日 (shippingDate)
    shippingDate: null,
    // 貨物種別 (shipmentDiv)
    shipmentDiv: null,
    // 貨物種別ラベル (shipmentDivLabel)
    shipmentDivLabel: null,
    // 伝票番号 (ytcNo)
    ytcNo: null,
    // 請求先情報 (billingInfo)
    billingInfo: {
      //  顧客コード (customerCd)
      customerCd: null,
      //  請求先名 (billToName)
      billToName: null,
      //  分類コード (classificationCd)
      classificationCd: null,
      //  運賃管理番号 (rateManagementNo)
      rateManagementNo: null
    }
  },

  // お届け先情報
  consigneeInfo: {
    // お届け先区分 (consigneeDiv)
    consigneeDiv: null,
    // お届け先区分ラベル (consigneeDivLabel)
    consigneeDivLabel: null,
    // お届け先・名 (consigneeName)
    consigneeName: null,
    // お届け先・国コード (consigneeCountryCd)
    consigneeCountryCd: null,
    // お届け先・国 (consigneeCountry)
    consigneeCountry: null,
    // お届け先・エリア (consigneeCityCd)
    consigneeCityCd: null,
    // お届け先・エリアラベル (consigneeCityLabel)
    consigneeCityLabel: null,
    // お届け先・USCIコードまたはOCコード区分 (consigneeUsciOcDiv)
    consigneeUsciOcDiv: null,
    // お届け先・USCIコードまたはOCコード区分ラベル (consigneeUsciOcDivLabel)
    consigneeUsciOcDivLabel: null,
    // お届け先・USCIコードまたはOCコード (consigneeUsciOcCd)
    consigneeUsciOcCd: null,
    // お届け先・電話番号 (consigneePhone)
    consigneePhone: null,
    // お届け先・郵便番号 (consigneeZip)
    consigneeZip: null,
    // お届け先・州コード (consigneeStateCd)
    consigneeStateCd: null,
    // お届け先・州 (consigneeAddress1)
    consigneeAddress1: null,
    // お届け先・都市 (consigneeAddress2)
    consigneeAddress2: null,
    // お届け先・住所 (consigneeAddress3)
    consigneeAddress3: null,
    // お届け先・会社名・部署名 (consigneeAddress4)
    consigneeAddress4: null
  },

  // ご依頼主情報
  shipperInfo: {
    // ご依頼主・名 (shipperName)
    shipperName: null,
    // ご依頼主・法人番号または税関輸出入者コード (shipperOrganizationCd)
    shipperOrganizationCd: null,
    // ご依頼主・電話番号 (shipperPhone)
    shipperPhone: null,
    // ご依頼主・郵便番号 (shipperZip)
    shipperZip: null,
    // ご依頼主・都道府県 (shipperAddress1)
    shipperAddress1: null,
    // ご依頼主・市・区・郡 (shipperAddress2)
    shipperAddress2: null,
    // ご依頼主・町・番地・建物名 (shipperAddress3)
    shipperAddress3: null,
    // ご依頼主・会社名・部署名 (shipperAddress4)
    shipperAddress4: null
  },

  // クール区分
  coolDiv: null,
  // クール区分ラベル
  coolDivLabel: null,
  // 運賃の支払い方法
  feePaymentDiv: null,
  // 関税等諸費用の支払い方法
  taxPaymentDiv: null,
  // 関税等諸費用の支払い方法ラベル
  taxPaymentDivLabel: null,
  // VAT種類
  vatRegisterDiv: null,
  // VAT種類（表示用）
  vatRegisterDivName: null,
  // VAT番号
  vatRegisterNumber: null,
  // インボイス出力区分
  invoiceOutDiv: null,
  // 再発行枚数
  reissueCount: null,
  // 仕分けコード(Document)
  sortCodeD: null,
  // 仕分けコード(Non Document)
  sortCodeN: null,
  // 国際宅急便/国際パーセルサービス区分
  takkyubinDiv: null,
  // お問い合わせ先電話番号
  contactNumber: null,

  // 荷物設定情報
  packageInfo: {
    // Array object 荷物情報
    // パッケージID (packageId)
    packageId: null,
    // 実重量 (grossWeight)
    grossWeight: null,
    // 正味重量 (netWeight)
    netWeight: null,
    // 商品価格合計 itemTotal
    itemTotal: null,
    // 有償／無償 (paidDiv)
    paidDiv: null,
    // 有償／無償ラベル (paidDivLabel)
    paidDivLabel: null,
    // 重量単位コード (weightUnitCd)
    weightUnitCd: null,
    // 通貨 (currencyCd)
    currencyCd: null,
    // 建値 (shipmentTerm)
    shipmentTerm: null,
    // 縦幅 (length)
    length: null,
    // 横幅 (width)
    width: null,
    // 高さ (height)
    height: null,
    // 備考１ (note1)
    note1: null,
    // 備考２ (note2)
    note2: null,
    // 代表品目名 (representativeItemName)
    representativeItemName: null,
    // トラッキング番号 (trackingNo)
    trackingNo: null,
    //  品目情報 (itemInfo)
    itemInfo: []
    //  Array object 品目情報
    //   品目コード (itemCd)
    //   品名 (itemNm)
    //   HSコード (hsCd)
    //   原産国ID (originCountryId)
    //   原産国コード (originCountryCd)
    //   原産国 (originCountry)
    //   単価 (valueOfUnit)
    //   単位コード (unitCd)
    //   単位名＿英語 (unitName)
    //   個数 (quantity)
  }
};

const initState = {
  // 送り状発行情報
  shipment: shipment,
  duplicateList: [],
  masterData: {
    listBill: [],
    takkyubinCountryList: [],
    listOriginCountry: [],
    countryList: [],
    listTaxIdInfo: [],
    stateList: [],
    listCargos: [],
    listOtodoke: [],
    listDestinationState: [],
    listService: [],
    coolOfferKbn: null,
    isCoolFlag01: false,
    listPaymentDiv: [],
    listPaidFreeKbn: [],
    listCoolKbn: [],
    listUnit: [],
    listWeightLimit: [],
    listSizeLimit: [],
    listInvoiceByDocument: [],
    listInvoiceByNonDocument: [],
    listVatRegisterDiv: [],
    listVatRegisterNotice: [],
    listVatRegisterHint: [],
    currencyCd: null,
    shipmentTerm: null,
    weightUnidCd: null,
    lengthUnidCd: null
  },
  recordCount: 0
};

function getTakkyubinCountries(data) {
  return data.takkyubinCountryResponse
    ? data.takkyubinCountryResponse.takkyubinCountryList
    : [];
}

function getOriginCountries(data) {
  return data.originCountryResponse
    ? data.originCountryResponse.originCountryList
    : [];
}

function getCountries(data) {
  return data.countryResponse ? data.countryResponse.countryList : [];
}

function getItemInfo(key, data) {
  if (!data.generalItemResponse || !data.generalItemResponse.queriedItemsInfo) {
    return [];
  }
  const queriedItemsInfo = data.generalItemResponse.queriedItemsInfo;
  const sbtIDList = queriedItemsInfo.find(
    item => item.sbtID === key && item.sbtIDList
  );

  return sbtIDList ? sbtIDList.sbtIDList : [];
}

function getBills(data) {
  const listBill = data.billingInfo;
  return listBill.map(item => {
    let billToNameDisplay = item.customerCd;
    if (item.classificationCd) {
      billToNameDisplay += `-${item.classificationCd}`;
    }

    if (item.rateManagementNo) {
      billToNameDisplay += ` ${item.rateManagementNo}`;
    }

    const customerInfo = getCustomerInfo(data, item);

    return {
      billToNameDisplay,
      customerCd: item.customerCd,
      coolFlag: customerInfo && customerInfo.coolFlag,
      classificationCd: item.classificationCd ? item.classificationCd : null,
      rateManagementNo: item.rateManagementNo ? item.rateManagementNo : null,
      billToName: item.billToName ? item.billToName : null
    };
  });
}

function getCustomerInfo(data, item) {
  const customerList =
    data.specialCustomerResponse && data.specialCustomerResponse.customerList;
  return customerList.find(
    customer =>
      customer.customerCode === item.customerCd &&
      customer.customerSubCode === item.classificationCd
  );
}

function isCoolFlag01(data) {
  const customerList =
    data.specialCustomerResponse && data.specialCustomerResponse.customerList;
  if (customerList) {
    return customerList.some(item => item.coolFlag === "1");
  }
  return false;
}

function getCoolOfferKbn(data) {
  const listCoolOfferKbn = getItemInfo(GeneralItemKey.COOL_OFFER_KBN, data);
  return listCoolOfferKbn && listCoolOfferKbn[0].sbtNaiID;
}

const getters = {
  shipment: state => state.shipment,
  duplicateList: state => state.duplicateList,
  listBillMaster: state => state.masterData.listBill,
  takkyubinCountryListMaster: state => state.masterData.takkyubinCountryList,
  listOriginCountryMaster: state => state.masterData.listOriginCountry,
  countryListMaster: state => state.masterData.countryList,
  listTaxIdInfo: state => state.masterData.listTaxIdInfo,
  stateListMaster: state => state.masterData.stateList,
  listCargosMaster: state => state.masterData.listCargos,
  listOtodokeMaster: state => state.masterData.listOtodoke,
  listDestinationState: state => state.masterData.listDestinationState,
  listService: state => state.masterData.listService,
  coolOfferKbn: state => state.masterData.coolOfferKbn,
  isCoolFlag01: state => state.masterData.isCoolFlag01,
  listPaymentDiv: state => state.masterData.listPaymentDiv,
  listPaidFreeKbn: state => state.masterData.listPaidFreeKbn,
  listCoolKbn: state => state.masterData.listCoolKbn,
  listUnit: state => state.masterData.listUnit,
  listWeightLimit: state => state.masterData.listWeightLimit,
  listSizeLimit: state => state.masterData.listSizeLimit,
  listInvoiceByDocument: state => state.masterData.listInvoiceByDocument,
  listInvoiceByNonDocument: state => state.masterData.listInvoiceByNonDocument,
  listVatRegisterDiv: state => state.masterData.listVatRegisterDiv,
  listVatRegisterNotice: state => state.masterData.listVatRegisterNotice,
  listVatRegisterHint: state => state.masterData.listVatRegisterHint,
  currencyCd: state => state.masterData.currencyCd,
  shipmentTerm: state => state.masterData.shipmentTerm,
  weightUnidCd: state => state.masterData.weightUnidCd,
  lengthUnidCd: state => state.masterData.lengthUnidCd,
  recordCount: state => state.recordCount
};

const mutations = {
  setMasterData(state, data) {
    const _masterData = state.masterData;
    _masterData.takkyubinCountryList = getTakkyubinCountries(data);
    _masterData.listBill = getBills(data);
    _masterData.listOriginCountry = getOriginCountries(data);
    _masterData.countryList = getCountries(data);
    if (data.taxIdInfoResponse) {
      _masterData.listTaxIdInfo = data.taxIdInfoResponse.taxIdInfoList || [];
    }
    if (data.upsCountryResponse) {
      _masterData.stateList = data.upsCountryResponse.countryList || [];
    }
    _masterData.listCargos = getItemInfo(GeneralItemKey.CARGO_TYPE, data);
    _masterData.listOtodoke = getItemInfo(GeneralItemKey.OTODOKE_KBN, data);
    _masterData.listService = getItemInfo(GeneralItemKey.SERVICE_KBN, data);
    _masterData.coolOfferKbn = getCoolOfferKbn(data);
    _masterData.isCoolFlag01 = isCoolFlag01(data);
    _masterData.listPaymentDiv = getItemInfo(GeneralItemKey.PAYMENT_DIV, data);
    _masterData.listWeightLimit = getItemInfo(
      GeneralItemKey.WEIGHT_LIMIT,
      data
    );
    _masterData.listSizeLimit = getItemInfo(GeneralItemKey.SIZE_LIMIT, data);

    _masterData.listPaidFreeKbn = getItemInfo(
      GeneralItemKey.PAID_FREE_KBN,
      data
    );
    _masterData.listCoolKbn = getItemInfo(GeneralItemKey.COOL_KBN, data);
    if (data.unitResponse) {
      _masterData.listUnit = data.unitResponse.unitList || [];
    }

    _masterData.listInvoiceByDocument = getItemInfo(
      GeneralItemKey.INVOICE_BY_DOCUMENT,
      data
    );
    _masterData.listInvoiceByNonDocument = getItemInfo(
      GeneralItemKey.INVOICE_BY_NON_DOCUMENT,
      data
    );
    _masterData.listVatRegisterDiv = getItemInfo(
      GeneralItemKey.VAT_REGISTER_DIV,
      data
    );
    _masterData.listVatRegisterNotice = getItemInfo(
      GeneralItemKey.VAT_REGISTER_DIV_NOTICE,
      data
    );
    _masterData.listVatRegisterHint = getItemInfo(
      GeneralItemKey.VAT_REGISTER_DIV_HINT,
      data
    );

    const currencyCd = getItemInfo(GeneralItemKey.CURRENCY_CD, data);
    _masterData.currencyCd = currencyCd && currencyCd[0];

    const shipmentTerm = getItemInfo(GeneralItemKey.SHIPMENT_TERM, data);
    _masterData.shipmentTerm = shipmentTerm && shipmentTerm[0];

    const weightUnidCd = getItemInfo(GeneralItemKey.WEIGHT_UNID_CD, data);
    _masterData.weightUnidCd = weightUnidCd && weightUnidCd[0];

    const lengthUnidCd = getItemInfo(GeneralItemKey.LENGTH_UNID_CD, data);
    _masterData.lengthUnidCd = lengthUnidCd && lengthUnidCd[0];
  },
  setDestinationStateByCountry(state, data) {
    const countries = data.countryList && data.countryList[0];
    const states = countries && countries.stateList;
    const cities = states && states[0].cityList;
    if (cities) {
      state.masterData.listDestinationState = cities.map(item => {
        return {
          name: item.cityName
        };
      });
    }
  },
  resetState(state) {
    Object.assign(state, initState);
  },
  setShipmentData(state, shipment) {
    if (shipment) {
      state.shipment = shipment;
    }
  },
  setDuplicateList(state, duplicateList) {
    if (duplicateList) {
      state.duplicateList = duplicateList;
    }
  },
  setRecordCount(state, recordCount) {
    if (recordCount) {
      state.recordCount = +recordCount;
    }
  }
};

const actions = {
  async init({ commit }, params) {
    const { callBack } = params;

    await Vue.axios.get("/kyg021001/init").then(res => {
      const data = res.data;
      if (data) {
        commit("setMasterData", data);
        callBack && callBack();
      }
    });
  },
  reset({ commit }) {
    commit("resetState");
  },
  getDestinationStates({ commit }, params) {
    return new Promise(res => {
      const postBody = {
        countryCd: params.countryCd,
        stateCd: params.stateCd
      };
      Vue.axios
        .post("/kyg021001/destination-state", postBody, {})
        .then(response => {
          const data = response && response.data;
          if (data) {
            commit("setDestinationStateByCountry", data);
            res();
          }
        });
    });
  },
  async settingSavedShippingInfos({ commit }, shipmentNo) {
    const shipOrder = {
      shipmentNo: shipmentNo
    };
    const dataPost = { shipOrderList: [shipOrder] };
    await Vue.axios
      .post("/kyg071001/setting-saved-shipping-infos", dataPost)
      .then(res => {
        const data = res && res.data;
        if (data) {
          const shipOrderList = data.shipOrderList;
          if (shipOrderList && shipOrderList.length > 0) {
            const shipment = shipOrderList[0];
            commit("setShipmentData", shipment);
          }
          commit("setRecordCount", data.recordCount);
        }
      });
  },
  settingHistoryShippingInfos({ commit }, shipmentInfo) {
    commit("setShipmentData", shipmentInfo);
  },
  settingDuplicateList({ commit }, duplicateList) {
    commit("setDuplicateList", duplicateList);
  }
};

export default {
  namespaced: true,
  state: initState,
  getters,
  mutations,
  actions
};
